import React from 'react'
import seta from './images/seta-direita.png'
export const SetaDireita = (props) => <img src={seta} alt="Próxima página" {...props} />
